import { render, staticRenderFns } from "./legeDialog.vue?vue&type=template&id=14258dac&scoped=true&"
import script from "./legeDialog.vue?vue&type=script&lang=js&"
export * from "./legeDialog.vue?vue&type=script&lang=js&"
import style0 from "./legeDialog.vue?vue&type=style&index=0&id=14258dac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14258dac",
  null
  
)

export default component.exports